import { enqueueSnackbar } from "notistack";
import { useTranslation } from "react-i18next";

import CommonAlert from "@/components/CommonAlert";
import { useUpdateUserShiftTypeMutation } from "@/requests/user.mutations";
import { useUsersShiftTypeInfo, useUsersTableActions } from "@/stores/use-users-table";

function UserUpdateShiftDialog() {
    const { t } = useTranslation();
    const { mutateAsync, isPending } = useUpdateUserShiftTypeMutation();

    const shiftTypeInfo = useUsersShiftTypeInfo();
    const { updateShiftTypeInfo } = useUsersTableActions();
    const handleConfirm = async () => {
        if (isPending || !shiftTypeInfo) return;
        try {
            const res = await mutateAsync(shiftTypeInfo);
            enqueueSnackbar(t(res.message || ""), { variant: "success" });
        } catch (error) {
            console.error("IsDeletion error:", error);
        }
        handleClose();
    };
    const handleClose = () => {
        updateShiftTypeInfo(null);
    };

    return (
        <CommonAlert
            open={!!shiftTypeInfo}
            loading={isPending}
            description="confirmations.updateShiftType"
            color="primary"
            onClose={handleClose}
            handleConfirm={handleConfirm}
            html
            descriptionOpts={{
                name: shiftTypeInfo?.name || "",
                count: shiftTypeInfo?.isDisabled ? 1 : 2,
            }}
        ></CommonAlert>
    );
}

export default UserUpdateShiftDialog;
